module.exports = __webpack_public_path__ + "img/race_1248.cd58cf45.png";